import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import { Menu } from 'semantic-ui-react';

import { SatCoreRegister } from '../SatCoreRegistry';
import { ASSIGNMENT_MENU_STATUS } from '../managers/AssignmentManager';

const StudentAssignmentMenuStatusTabs = observer((props = {}) => {
  const {
    activeMenuStatus,
    loading,
    loadingClassName,
    onClick,
    t
  } = props;

  const { /* managers */ } = useContext(MobXProviderContext);

  return (
    <div className='StudentAssignmentMenuStatusTabs sa-menu-control'>
      <Menu className='student-menu'>
        {[
          [t('CurrentAssignments'), ASSIGNMENT_MENU_STATUS.CURRENT],
          [t('DueTodayAssignments'), ASSIGNMENT_MENU_STATUS.TODAY],
          [t('ClosedAssignments'), ASSIGNMENT_MENU_STATUS.CLOSED],
          [t('GradedAssignments'), ASSIGNMENT_MENU_STATUS.GRADED]
        ].map(([children, status]) => (
          <Menu.Item key={status}
            active={activeMenuStatus === status}
            as='button'
            className={classNames(status, {
              [loadingClassName]: loading
            })}
            name={status}
            onClick={onClick}
            tabIndex='0'>
            <div>{children}</div>
          </Menu.Item>
        ))}
      </Menu>
    </div>
  );
});
export default StudentAssignmentMenuStatusTabs;

SatCoreRegister('StudentAssignmentMenuStatusTabs', StudentAssignmentMenuStatusTabs);
